export default "__VITE_ASSET__CAWSg4Bj__"